import React, { Component } from 'react';

//Core Libs
import prd from "../Core/Products";

// Componets
import ProductNode 		from '../Reducer/ProductNode';


class FeaturedProducts extends Component {
    
    constructor(props){
        
        super(props);

        this.state = {
            featuredProducts: {}
        };
        
    }
    
    componentWillMount() {		
		this.getFeaturedProducts();
	}


	getFeaturedProducts = () => {
		
		prd.getFeaturedCycles( (response) => {
			this.setState({
				featuredProducts: response.data
			});
		});

    }
    
    render() {
        
        let featuredProducts = (
			<div className="row">
				<div className="col-xs-12 col-sm-6 col-md-4">
					<ProductNode loading={'loading'}/>
				</div>
				<div className="col-xs-12 col-sm-6 col-md-4 hidden-sm">
					<ProductNode loading={'loading'}/>
				</div>
				<div className="col-xs-12 col-sm-6 col-md-4 hidden-sm hidden-xs">
					<ProductNode loading={'loading'}/>
				</div>
			</div>
		);

		if(this.state.featuredProducts.length) {
			
			featuredProducts = (
				<div className="row">
					{
						this.state.featuredProducts.map(function(item, i){
							return(
								<div className="col-xs-12 col-sm-6 col-md-4" key={i}>
									<ProductNode item={item} />
								</div>					
							)
						})
					}
				</div>
			)


        }
        
		return (            
            <section className="container product-container">
                <header className="header header-main row">
                    <h2 className="col-md-12">Populære Cykler</h2>
                </header>
                    
                {featuredProducts}						

            </section>
		);
	}
}

export default FeaturedProducts;


// WEBPACK FOOTER //
// ./src/Components/FeaturedProducts.js